'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import { createDesignPreviewerUrl } from 'DesignData/lib/preview';
import { getUserHasReadAccessOnly } from 'DesignData/selectors/auth';
import * as CustomWidgetBufferActions from 'DesignData/actions/CustomWidgetBuffers';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import Toolbar from 'DesignEditorsUI/components/customWidgetEditor/Toolbar';
import * as EditorErrorsActions from 'DesignData/actions/EditorErrors';
import * as editorErrorSelectors from 'DesignData/selectors/editorErrors';
import EditorError from 'DesignData/models/validation/EditorError';

function makeMapStateToProps() {
  const getPastEditHistoryCount = customWidgetBuffersSelectors.makeGetPastEditHistoryCount();
  const getFutureEditHistoryCount = customWidgetBuffersSelectors.makeGetFutureEditHistoryCount();
  const getRequestStatus = customWidgetBuffersSelectors.makeGetRequestStatus();
  const getCustomWidgetBuffer = customWidgetBuffersSelectors.makeGetCustomWidgetBuffer();
  const getErrorsById = editorErrorSelectors.makeGetCombinedErrorsById();
  const getIsReadOnly = customWidgetBuffersSelectors.makeGetIsReadOnly();
  return (state, props) => {
    const {
      portal_id: portalId
    } = state.auth.portal;
    const {
      customWidgetId,
      revisionId
    } = props;
    const customWidgetBuffer = getCustomWidgetBuffer(state, props);
    const previewUrl = customWidgetBuffer ? createDesignPreviewerUrl(customWidgetBuffer, portalId, revisionId) : '';
    const hasBufferedChanges = customWidgetBuffer && customWidgetBuffer.isBuffered;
    return {
      customWidgetId,
      previewUrl,
      hasBufferedChanges,
      isBufferLoaded: !!customWidgetBuffer,
      schemaVersion: customWidgetBuffer && customWidgetBuffer.schemaVersion,
      isAvailableForNewContent: !!(customWidgetBuffer && customWidgetBuffer.isAvailableForNewContent),
      isEnabledForEmailV3Rendering: !!(customWidgetBuffer && customWidgetBuffer.isEnabledForEmailV3Rendering),
      futureEditHistoryCount: getFutureEditHistoryCount(state, props),
      isReadOnly: getUserHasReadAccessOnly(state) || getIsReadOnly(state, props),
      pastEditHistoryCount: getPastEditHistoryCount(state, props),
      requestStatus: getRequestStatus(state, props),
      editorErrors: getErrorsById(state, {
        assetId: props.customWidgetId
      })
    };
  };
}

const mapDispatchToProps = {
  publishCustomWidget: CustomWidgetBufferActions.publish,
  redoCustomWidgetEdit: CustomWidgetBufferActions.redoEdit,
  undoCustomWidgetEdit: CustomWidgetBufferActions.undoEdit,
  updateCustomWidget: CustomWidgetBufferActions.update,
  openDrawer: EditorErrorsActions.openDrawer
};

class ToolbarContainer extends Component {
  constructor(props) {
    super(props);
    this.onPublish = this.onPublish.bind(this);
    this.onRedoCustomWidgetEdit = this.onRedoCustomWidgetEdit.bind(this);
    this.onUndoCustomWidgetEdit = this.onUndoCustomWidgetEdit.bind(this);
    this.onUpdateCustomWidget = this.onUpdateCustomWidget.bind(this);
  }

  onPublish() {
    const {
      customWidgetId,
      publishCustomWidget
    } = this.props;
    publishCustomWidget(customWidgetId);
  }

  onRedoCustomWidgetEdit() {
    const {
      customWidgetId,
      redoCustomWidgetEdit
    } = this.props;
    redoCustomWidgetEdit(customWidgetId);
  }

  onUndoCustomWidgetEdit() {
    const {
      customWidgetId,
      undoCustomWidgetEdit
    } = this.props;
    undoCustomWidgetEdit(customWidgetId);
  }

  onUpdateCustomWidget(changes) {
    this.props.updateCustomWidget(this.props.customWidgetId, changes);
  }

  render() {
    const {
      customWidgetId,
      isReadOnly,
      previewUrl,
      requestStatus,
      futureEditHistoryCount,
      pastEditHistoryCount,
      openDrawer,
      editorErrors,
      hasBufferedChanges
    } = this.props;
    return /*#__PURE__*/_jsx(Toolbar, {
      isBufferLoaded: this.props.isBufferLoaded,
      isAvailableForNewContent: this.props.isAvailableForNewContent,
      isEnabledForEmailV3Rendering: this.props.isEnabledForEmailV3Rendering,
      schemaVersion: this.props.schemaVersion,
      customWidgetId: customWidgetId,
      futureEditHistoryCount: futureEditHistoryCount,
      isReadOnly: isReadOnly,
      onPublish: this.onPublish,
      onRedoCustomWidgetEdit: this.onRedoCustomWidgetEdit,
      onUndoCustomWidgetEdit: this.onUndoCustomWidgetEdit,
      pastEditHistoryCount: pastEditHistoryCount,
      previewUrl: previewUrl,
      requestStatus: requestStatus,
      openDrawer: openDrawer,
      editorErrors: editorErrors,
      hasBufferedChanges: hasBufferedChanges,
      onUpdateCustomWidget: this.onUpdateCustomWidget
    });
  }

}

ToolbarContainer.propTypes = {
  isBufferLoaded: PropTypes.bool.isRequired,
  isAvailableForNewContent: PropTypes.bool.isRequired,
  isEnabledForEmailV3Rendering: PropTypes.bool.isRequired,
  schemaVersion: PropTypes.number,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  futureEditHistoryCount: PropTypes.number.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  pastEditHistoryCount: PropTypes.number.isRequired,
  previewUrl: PropTypes.string,
  publishCustomWidget: PropTypes.func.isRequired,
  redoCustomWidgetEdit: PropTypes.func.isRequired,
  requestStatus: PropTypes.object.isRequired,
  undoCustomWidgetEdit: PropTypes.func.isRequired,
  openDrawer: PropTypes.func.isRequired,
  editorErrors: PropTypes.arrayOf(PropTypes.instanceOf(EditorError)),
  hasBufferedChanges: PropTypes.bool,
  updateCustomWidget: PropTypes.func.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(ToolbarContainer);